import React from 'react';
import { Select, Radio, Space } from 'antd';
import styles from '../style.module.less';
import ItemWrapper from '@/src/components/Layouts/Item/Item';

import {
  Cnversion,
  DecimalSeparator,
  ThousandsSeparator,
  DisplayFormat,
  TruncateRule,
} from '../constant';

const CurrencyConfigSection = ({
  currencyConfig,
  getI18n,
  decimalPositionOptions,
  conversionOptions,
  formatExample,
  renderRoundingExample,
  renderTruncatingExample,
  labelify,
  secondCuSymbol,
  edit_currency_settings,
  handleChangeDecimalPosition,
  handleChangePropsViaEvent,
  handleChangePropsViaValue,
  isReferenceCurrency = false,
}) => {
  const decimalPosition = isReferenceCurrency
    ? currencyConfig?.referenceDecimalPosition
    : currencyConfig?.decimalPosition;

  const conversionMode = isReferenceCurrency
    ? currencyConfig?.referenceConversionMode
    : currencyConfig?.conversionMode;

  const currencySymbol = isReferenceCurrency
    ? currencyConfig?.secondaryCurrencySymbol
    : currencyConfig?.currencySymbol;

  const currencyCode = isReferenceCurrency
    ? currencyConfig?.secondaryCurrencyCode
    : currencyConfig.currencyCode;

  const roundingRule = isReferenceCurrency
    ? currencyConfig?.referenceRoundingRule
    : currencyConfig.roundingRule;

  const truncateRule = isReferenceCurrency
    ? currencyConfig?.referenceTruncateRule
    : currencyConfig.truncateRule;

  const decimalSeparator = isReferenceCurrency
    ? currencyConfig?.referenceDecimalSeparator
    : currencyConfig?.decimalSeparator;

  const thousandsSeparator = isReferenceCurrency
    ? currencyConfig?.referenceThousandsSeparator
    : currencyConfig?.thousandsSeparator;

  const currencyDisplayFormat = isReferenceCurrency
    ? currencyConfig?.secondaryCurrencyDisplayFormat
    : currencyConfig?.currencyDisplayFormat;

  const symbolList = isReferenceCurrency
    ? labelify(secondCuSymbol)
    : labelify(currencyConfig?.currencySymbolList);

  return (
    <div className={styles.warpperBody}>
      <ItemWrapper
        containerClassName={`${styles.formatWrapperTop} ${
          isReferenceCurrency ? styles.referenceFormatWrapperTop : ''
        }`}
        title={
          <div>
            <span>{getI18n('salesChannelCurrency.index.decimalPlaces')}</span>
            <span style={{ marginLeft: '12px', fontWeight: 400 }}>
              ( 0 - 9 )
            </span>
          </div>
        }>
        <Select
          className={styles.select}
          size='large'
          onChange={(v) => {
            handleChangeDecimalPosition(
              currencyConfig.uuid,
              v,
              isReferenceCurrency,
            );
          }}
          value={typeof decimalPosition === 'number' ? decimalPosition : 2}
          options={decimalPositionOptions}
          disabled={!edit_currency_settings}
        />
        <ItemWrapper
          containerClassName={styles.bottomItemWrapper}
          title={getI18n('salesChannelCurrency.index.conversionModeTitle')}
          bottomTitle={getI18n(
            'salesChannelCurrency.index.conversionModeBottomTitle',
          )}>
          <Radio.Group
            value={conversionMode || Cnversion.Truncate}
            onChange={(e) =>
              handleChangePropsViaEvent(
                currencyConfig.uuid,
                isReferenceCurrency
                  ? 'referenceConversionMode'
                  : 'conversionMode',
                e,
                isReferenceCurrency,
              )
            }
            disabled={!edit_currency_settings}>
            <Space direction='vertical' className={styles.space}>
              {/* Round */}
              <div className={styles.item}>
                <Radio value={Cnversion.Round}>
                  {getI18n('salesChannelCurrency.index.roundnumbersdown')}
                </Radio>
                <div className={styles.body}>
                  <div className={styles.desc}>
                    {getI18n('salesChannelCurrency.index.roundnumbersdowntip')}
                  </div>
                  {conversionMode === Cnversion.Round && (
                    <>
                      <Select
                        className={styles.select}
                        size='large'
                        value={roundingRule || TruncateRule.HUNDREDTHS}
                        options={conversionOptions({ getI18n }).slice(
                          0,
                          (decimalPosition || 2) + 1,
                        )}
                        onChange={(val) =>
                          handleChangePropsViaValue(
                            currencyConfig.uuid,
                            isReferenceCurrency
                              ? 'referenceRoundingRule'
                              : 'roundingRule',
                            val,
                            isReferenceCurrency,
                          )
                        }
                        disabled={!edit_currency_settings}
                      />
                      <span className={styles.exmaple}>
                        {renderRoundingExample(currencyConfig)}
                      </span>
                    </>
                  )}
                </div>
              </div>

              {/* Truncate */}
              <div className={styles.item}>
                <Radio value={Cnversion.Truncate}>
                  {getI18n('salesChannelCurrency.index.truncating')}
                </Radio>
                <div className={styles.body}>
                  <div className={styles.desc}>
                    {getI18n('salesChannelCurrency.index.truncatingTip')}
                  </div>
                  {conversionMode === Cnversion.Truncate && (
                    <>
                      <Select
                        className={styles.select}
                        size='large'
                        value={truncateRule || TruncateRule.HUNDREDTHS}
                        options={conversionOptions({ getI18n }).slice(
                          0,
                          (decimalPosition || 2) + 1,
                        )}
                        onChange={(val) =>
                          handleChangePropsViaValue(
                            currencyConfig.uuid,
                            isReferenceCurrency
                              ? 'referenceTruncateRule'
                              : 'truncateRule',
                            val,
                            isReferenceCurrency,
                          )
                        }
                        disabled={!edit_currency_settings}
                      />
                      <span className={styles.exmaple}>
                        {renderTruncatingExample(currencyConfig)}
                      </span>
                    </>
                  )}
                </div>
              </div>
            </Space>
          </Radio.Group>
        </ItemWrapper>
      </ItemWrapper>

      {/* 分隔符配置 */}
      <ItemWrapper containerClassName={styles.formatWrapper}>
        <div className={styles.item}>
          <div className={styles.title}>
            {getI18n('salesChannelCurrency.index.decimalSeparator')}
          </div>
          <Radio.Group
            value={decimalSeparator}
            onChange={(e) =>
              handleChangePropsViaEvent(
                currencyConfig.uuid,
                isReferenceCurrency
                  ? 'referenceDecimalSeparator'
                  : 'decimalSeparator',
                e,
                isReferenceCurrency,
              )
            }
            disabled={!edit_currency_settings}>
            <Space direction='vertical'>
              <Radio value={DecimalSeparator.POINT}>
                {getI18n('salesChannelCurrency.index.decimalpoint')} (.)
              </Radio>
              <Radio value={DecimalSeparator.COMMA}>
                {getI18n('salesChannelCurrency.index.decimalcomma')} (,)
              </Radio>
            </Space>
          </Radio.Group>
        </div>

        <div className={styles.item}>
          <div className={styles.title}>
            {getI18n('salesChannelCurrency.index.thousandsSeparator')}
          </div>
          <Radio.Group
            value={thousandsSeparator}
            onChange={(e) =>
              handleChangePropsViaEvent(
                currencyConfig.uuid,
                isReferenceCurrency
                  ? 'referenceThousandsSeparator'
                  : 'thousandsSeparator',
                e,
                isReferenceCurrency,
              )
            }
            disabled={!edit_currency_settings}>
            <Space direction='vertical'>
              <Radio value={ThousandsSeparator.NOT_USE}>
                {getI18n('salesChannelCurrency.index.notuse')}
              </Radio>
              <Radio value={ThousandsSeparator.COMMA}>
                {getI18n('salesChannelCurrency.index.comma')} (,)
              </Radio>
              <Radio value={ThousandsSeparator.POINT}>
                {getI18n('salesChannelCurrency.index.point')} (.)
              </Radio>
              <Radio value={ThousandsSeparator.SPACE}>
                {getI18n('salesChannelCurrency.index.space')}
              </Radio>
            </Space>
          </Radio.Group>
        </div>
      </ItemWrapper>

      {/* 货币符号显示格式 */}
      <ItemWrapper containerClassName={styles.formatWrapperBottom}>
        <div className={styles.display}>
          {/* 主货币 */}
          <div className={styles.item}>
            <div className={styles.title}>
              {getI18n(
                'salesChannelCurrency.index.currencySymbolDisplayPrimaryCurrency',
              )}{' '}
              - {currencyCode}
            </div>
            <div className={styles.body}>
              <Radio.Group
                value={currencyDisplayFormat}
                onChange={(e) =>
                  handleChangePropsViaEvent(
                    currencyConfig.uuid,
                    isReferenceCurrency
                      ? 'secondaryCurrencyDisplayFormat'
                      : 'currencyDisplayFormat',
                    e,
                    isReferenceCurrency,
                  )
                }
                disabled={!edit_currency_settings}>
                <Space direction='vertical'>
                  {[
                    DisplayFormat.PREFIX_AMOUNT,
                    DisplayFormat.AMOUNT_SUFFIX,
                  ].map((format) => (
                    <div className={styles.radio} key={format}>
                      <Radio value={format}>
                        {getI18n(
                          format === DisplayFormat.PREFIX_AMOUNT
                            ? 'salesChannelCurrency.index.prefixAmount'
                            : 'salesChannelCurrency.index.amountSuffix',
                        )}
                      </Radio>
                      {currencyDisplayFormat === format && (
                        <div className={styles.option}>
                          <Select
                            onChange={(val) =>
                              handleChangePropsViaValue(
                                currencyConfig.uuid,
                                isReferenceCurrency
                                  ? 'secondaryCurrencySymbol'
                                  : 'currencySymbol',
                                val,
                                isReferenceCurrency,
                              )
                            }
                            value={currencySymbol}
                            options={symbolList}
                            className={styles.select}
                            size='large'
                            disabled={!edit_currency_settings}
                          />
                          <span className={styles.exmaple}>
                            {`${getI18n(
                              'salesChannelCurrency.index.eg',
                            )} ${formatExample(format, currencySymbol)}`}
                          </span>
                        </div>
                      )}
                    </div>
                  ))}
                </Space>
              </Radio.Group>
            </div>
          </div>

          {/* 参考币种 */}
          {/* {currencyConfig?.primary && (
            <div className={styles.item}>
              <div className={styles.title}>
                {getI18n(
                  'salesChannelCurrency.index.currencySymbolDisplaySecondaryCurrency',
                )}
              </div>
              <div className={styles.body}>
                {currencyConfig.showSecondary &&
                currencyConfig.secondaryCurrencyCode ? (
                  <Radio.Group
                    value={currencyConfig.secondaryCurrencyDisplayFormat}
                    onChange={(e) => {
                      handleChangePropsViaEvent(
                        currencyConfig.uuid,
                        'secondaryCurrencyDisplayFormat',
                        e,
                      );
                    }}
                    disabled={!edit_currency_settings}>
                    <Space direction='vertical'>
                      {[
                        DisplayFormat.PREFIX_AMOUNT,
                        DisplayFormat.AMOUNT_SUFFIX,
                      ].map((format) => (
                        <div className={styles.radio} key={format}>
                          <Radio value={format}>
                            {getI18n(
                              format === DisplayFormat.PREFIX_AMOUNT
                                ? 'salesChannelCurrency.index.prefixAmount'
                                : 'salesChannelCurrency.index.amountSuffix',
                            )}
                          </Radio>
                          {currencyConfig.secondaryCurrencyDisplayFormat ===
                            format && (
                            <div className={styles.option}>
                              <Select
                                onChange={(e) => {
                                  handleChangePropsViaValue(
                                    currencyConfig.uuid,
                                    'secondaryCurrencySymbol',
                                    e,
                                  );
                                }}
                                value={currencyConfig.secondaryCurrencySymbol}
                                options={labelify(secondCuSymbol)}
                                className={styles.select}
                                size='large'
                                disabled={!edit_currency_settings}
                              />
                              <span className={styles.exmaple}>
                                {`${getI18n(
                                  'salesChannelCurrency.index.eg',
                                )} ${formatExample(
                                  format,
                                  currencyConfig.secondaryCurrencySymbol,
                                )}`}
                              </span>
                            </div>
                          )}
                        </div>
                      ))}
                    </Space>
                  </Radio.Group>
                ) : (
                  <span>
                    {getI18n('salesChannelCurrency.index.showSecondaryTip')}
                  </span>
                )}
              </div>
            </div>
          )} */}
        </div>
      </ItemWrapper>
    </div>
  );
};

export default CurrencyConfigSection;
